import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import SubscribeForm from 'components/Form/SubscribeForm';
import { GateFormContainer } from '../styles';

const GatedSubscribeForm = ({ increaseCookie, children, gatedForm, ...otherProps }) => {
  const [isUpdate, setUpdate] = useState(false);
  const getCookieNum = () => {
    return parseInt(Cookies.get('gate-subscribe-count') || 0, 10);
  };

  const setCookieNum = num => {
    Cookies.set('gate-subscribe-count', num);
  };

  useEffect(() => {
    if (increaseCookie > 0 && getCookieNum() < 2) {
      setCookieNum(getCookieNum() + 1);
      setUpdate(!isUpdate);
    }
  }, [increaseCookie]);

  const handleSuccess = () => {
    setCookieNum(3);
    setUpdate(!isUpdate);
  };

  return (
    <GateFormContainer>
      {getCookieNum() === 2 && gatedForm ? (
        <div className="section-gate-form--submit-form">
          <h4 className="section-gate-form--submit-form-title">{gatedForm.formTitle}</h4>

          <div data-testid="gated-subscribe-form" className="gate-form--subscribe-form">
            <SubscribeForm
              className="gate-form--subscribe-marketo-form"
              label=""
              marketoForm={gatedForm.marketoForm}
              buttonType="secondary"
              notificationMessage="Thanks for subscribing!"
              shouldRedirect={false}
              formType="Email Capture | tools gate form"
              dataPosition="tools gate form"
              onSuccess={handleSuccess}
            />
          </div>
        </div>
      ) : (
        children
      )}
    </GateFormContainer>
  );
};

export default GatedSubscribeForm;
